import React, { Dispatch, FC } from 'react';

import { Header } from './header';
import { TableContent } from './table-content';
import { useTableHook } from 'hooks/table/useStickyTable';
import { IColumnSortingInfo, ITableColumn } from 'types/table';

import styles from './styles.module.css';

interface ITableProps {
  isLoading: boolean;
  withMap?: boolean;
  offset?: number;
  selectedRowIds?: string[];
  columns: ITableColumn[];
  data: Record<string, unknown>[];
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
  onRowClick?: Dispatch<any>;
}

export const StickyTable: FC<ITableProps> = ({ offset, withMap, ...rest }) => {
  const { headerProps, contentProps, getTableProps } = useTableHook(rest);

  return (
    <div style={{ position: 'relative' }}>
      <div
        {...getTableProps()}
        className={`${styles.table} ${styles.sticky}`}
        style={{
          height: `calc(100vh - ${offset ? offset : 387}px)`,
          width: withMap ? `${0.6 * window.innerWidth}px` : `${window.innerWidth - 64}px`,
        }}
      >
        <Header {...headerProps} />
        <TableContent {...contentProps} />
      </div>
    </div>
  );
};
